import { createFileRoute, redirect } from "@tanstack/react-router";

/** Kept so old links still land. Emergency contacts and POA moved to Profile; family lives on
 * Family. */
export const Route = createFileRoute("/_authenticated/_care/residents/$residentId/contacts")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/residents/$residentId/family", params });
  },
});
